/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ filter: NonNullable<unknown> }} Error_Nav_No_Errors_Found_ToastInputs */

const en_error_nav_no_errors_found_toast = /** @type {(inputs: Error_Nav_No_Errors_Found_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No${i?.filter} errors found.`)
};

const fr_error_nav_no_errors_found_toast = /** @type {(inputs: Error_Nav_No_Errors_Found_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aucune${i?.filter} erreur trouvee.`)
};

const de_error_nav_no_errors_found_toast = /** @type {(inputs: Error_Nav_No_Errors_Found_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Es wurden keine ${i?.filter}-Fehler gefunden.`)
};

const es_error_nav_no_errors_found_toast = /** @type {(inputs: Error_Nav_No_Errors_Found_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se encontraron errores${i?.filter}.`)
};

const zh_cn2_error_nav_no_errors_found_toast = /** @type {(inputs: Error_Nav_No_Errors_Found_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`未发现${i?.filter}错误。`)
};

const ja_error_nav_no_errors_found_toast = /** @type {(inputs: Error_Nav_No_Errors_Found_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.filter} エラーは見つかりませんでした。`)
};

const hi_error_nav_no_errors_found_toast = /** @type {(inputs: Error_Nav_No_Errors_Found_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No${i?.filter} त्रुटियाँ पाई गईं।`)
};

/**
* | output |
* | --- |
* | "No{filter} errors found." |
*
* @param {Error_Nav_No_Errors_Found_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_no_errors_found_toast = /** @type {((inputs: Error_Nav_No_Errors_Found_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_No_Errors_Found_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_no_errors_found_toast(inputs)
	if (locale === "de") return de_error_nav_no_errors_found_toast(inputs)
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun errore trovato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибок PH0 не обнаружено.")
	if (locale === "es") return es_error_nav_no_errors_found_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_no_errors_found_toast(inputs)
	if (locale === "ja") return ja_error_nav_no_errors_found_toast(inputs)
	if (locale === "hi") return hi_error_nav_no_errors_found_toast(inputs)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum erro PH_0__ encontrado.")
	return en_error_nav_no_errors_found_toast(inputs)
});